import { render, staticRenderFns } from "./PublicUpperSidebarLink.vue?vue&type=template&id=6cc899a4&scoped=true&"
import script from "./PublicUpperSidebarLink.vue?vue&type=script&lang=js&"
export * from "./PublicUpperSidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc899a4",
  null
  
)

export default component.exports